module.exports = __webpack_public_path__ + "img/qrcode_official.f037bf43.png";